import Vue from 'vue'
import Vuex from 'vuex'

import users from '@/store/services/users'
import auth from '@/store/modules/auth'
import categories from '@/store/modules/categories'
import tags from '@/store/modules/tags'
import photos from '@/store/modules/photos'
import createPersistedState from "vuex-persistedstate";
import messages from '@/store/modules/messages'
import filters from '@/store/modules/filters'
import settings from '@/store/modules/settings'
import photoGroups from '@/store/modules/photoGroups'
import status from '@/store/modules/status'
import countItems from '@/store/modules/countItems'
import verification from '@/store/modules/verification'
import boxes from '@/store/modules/boxes'

Vue.use(Vuex)

function index(obj, is, value) {
    let new_obj;
    if (typeof is == 'string')
        return index(obj,is.split('.'), value);
    else if (is.length == 1 && value !== undefined)
        return obj[is[0]] = value;
    else if (is.length == 0)
        return obj;
    else
        if (is[0].includes('[')) {
            let split_is = is[0].split('[')
            new_obj = obj[split_is[0]][split_is[1].replace('[', '').replace(']', '')];
        } else {
            new_obj = obj[is[0]];
        }
        return index(new_obj, is.slice(1), value);
}

const store = new Vuex.Store({
  modules: {
    users,
    auth,
    categories,
    tags,
    photos,
    messages,
    filters,
    settings,
    photoGroups,
    status,
    countItems,
    verification,
    boxes
  },
  state: {
      loading_list: [

      ]
  },
  plugins: [createPersistedState({
    paths: ['auth']
  })],
  mutations: {
      UPDATE_STORE_DATA(state, data) {
          // data === [ { keys: 'key.key.key', value: string || array || number || etc } ]
          // data.keys === string of dot notation keys that represent the hierarchy to the data point you need
          // data.value === whatever you want to set the data point to

          // EXAMPLE:
          // UPDATE_STORE_DATA({
          //     fields: [
          //         { keys: 'snackbar.show', value: false }
          //     ]
          // })

          for (let field of data.fields) {
              index(state, field.keys, field.value);
          }
      },
      UPDATE_STORE_ARRAY_DATA(state, data) {
          // data === [ { keys: 'key.key.key', value: string || number || etc } ]
          // data.keys === string of dot notation keys that represent the hierarchy to the data point you need
          // data.value === whatever you want to toggle or put in the array || index for del_index || {idx, value} for put_index
          // data.action === what do you need to do with this array || 'toggle' | 'put' | 'put_index' | 'del_index'
          // WHY: UPDATE_STORE_DATA simply allows for replacing the array, this allows manipulation of the array
          // A common use case would be adding/removing a function name from the loading list.

          // EXAMPLE:
          // UPDATE_STORE_ARRAY_DATA({
          //     fields: [
          //         { keys: 'loading_list', value: 'function_name', action: 'toggle' }
          //     ]
          // })

          let data_point;

          for (let field of data.fields) {
              data_point = index(state, field.keys);

              if (field.action === 'toggle' && data_point.indexOf(field.value) != -1) {
                  data_point = data_point.filter(item => item !== field.value);
              } else if (field.action === 'put_index') {
                  data_point.splice(field.value.idx, 1, field.value.value);
              } else if (field.action === 'del_index') {
                  data_point.splice(field.value, 1);
              } else {
                  data_point.push(field.value);
              }

              index(state, field.keys, data_point);
          }
      },
  }
})

export default store
